import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import ReactModal from 'react-modal';
import { BrowserRouter } from 'react-router-dom';
import { applyLogPrefix } from '@chronos/log';
import configureStore from './store/configureStore';

import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import Routes from './Routes';
import GlobalStyles from './styled/styled-global';
import initializeSentry from './utils/initializeSentry';
import fixMobileBrowserHeight from './utils/fixMobileBrowserHeight';
import appReducer from './slices/appSlice';
import modalReducer from './slices/modalSlice';
import config from './config';
import AppThemeProvider from './contexts/AppThemeProvider';

initializeSentry();
log.setLevel(config.logLevel);
applyLogPrefix('[pwa]');
fixMobileBrowserHeight();

// Initialize deferredPrompt for use later to show browser install prompt.
window.deferredPrompt = null;

window.addEventListener('beforeinstallprompt', (e) => {
  log.info('beforeinstallprompt');
  // Prevent the mini-infobar from appearing on mobile
  e.preventDefault();
  // Stash the event so it can be triggered later.
  window.deferredPrompt = e;
});

const rootEl = document.getElementById('root');
const root = createRoot(rootEl);

const store = configureStore({
  app: appReducer,
  modal: modalReducer,
});
const render = () =>
  root.render(
    <Provider store={store}>
      <AppThemeProvider>
        <GlobalStyles />
        <BrowserRouter>
          <Routes />
        </BrowserRouter>
      </AppThemeProvider>
    </Provider>
  );

ReactModal.setAppElement(rootEl);
render();

// serviceWorkerRegistration.unregister({
serviceWorkerRegistration.register({
  onSuccess: () => {
    log.info('Service worker registered');
  },
  onUpdate: () => {
    log.info('Service worker updated');
  },
});
